<template>
  <main class="dashboard contact">
    <div class="container-fluid container-fluid--max">
      <notification></notification>
      <div class="card">
        <div class="dash-contact card-body">
          <h1 class="dashboard__title heading-secondary">Demande de contact</h1>
          <div class="row px-lg-5 mt-4">
            <!-- <vv-observer tag="form" v-slot="{ invalid }" class="col-md" @submit.prevent="submit">
              <vv-provider tag="div" class="form-group" v-slot="{ errors, classes }" rules="required" name="message" ref="message">
                <label class="access-form__label">
                  Message
                  <abbr title="Ce champ est obligatoire">*</abbr>
                </label>
                <textarea v-model="message" class="contact__textarea form-control" :class="{ 'is-invalid': error.message || classes.invalid }"></textarea>
                <small class="text-danger">{{ errors[0] }}</small>
                <small class="text-danger">{{ error.message }}</small>
              </vv-provider>
              <s-button :loading="loading" @submit="submit" :disabled="invalid" :css-class="'btn-block btn-' + $mainColor">
                Envoyer
              </s-button>
            </vv-observer> -->
            <section class="col-md">
              <h2 class="heading-secondary d-md-none separator-x pt-3 mt-4">Nos informations</h2>
              <div class="contact__infos">
                <div class="contact__info d-flex align-items-center my-3">
                  <i class="contact__icon fa fa-envelope fa-fw text-white round p-3" :class="'bg-' + $mainColor" aria-hidden="true"></i>
                  <span>{{ $root.contactEmail }}</span>
                </div>
                <div class="contact__info d-flex align-items-center my-3">
                  <i class="contact__icon fa fa-phone-square fa-fw text-white round p-3" :class="'bg-' + $mainColor" aria-hidden="true"></i>
                  <span>
                    Tel : {{ $root.contactPhone }}
                    <br>
                    Fax : 09 72 43 12 90
                  </span>
                </div>
                <div class="contact__info d-flex align-items-center my-3">
                  <i class="contact__icon fa fa-map fa-fw text-white round p-3" :class="'bg-' + $mainColor" aria-hidden="true"></i>
                  <span>
                    {{ $root.contactAddress }},
                    <br>
                    {{ $root.contactCity }}
                  </span>
                </div>
              </div>
            </section>
            <section class="col-md">
              <Gmap :lat="$root.contactLatitude" :lng="$root.contactLongitude" id="contact" />
            </section>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Gmap from '@/components/ui/Gmap'

export default {
  name: 'ContactForm',
  components: {
    Gmap
  },
  props: {
    url: {
      type: String,
      required: true
    },
    auth: {
      type: Object,
      required: true
    },
    accountType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      message: null,
      error: {}
    }
  },
  methods: {
    submit () {
      this.loading = true
      let params = {
        message: this.message,
        registered_for: this.$appName,
        account_type: this.accountType
      }
      this.$http.post(this.url + '/contact', params, {
        headers: this.auth
      }).then(resp => {
        this.loading = false
        this.$store.dispatch('setNotification', {
          message: 'Votre message a bien été envoyé.',
          mode: 'success'
        })
      }).catch(err => {
        this.loading = false
        this.errors = {}
        if (err.response.status === 422) {
          let e = err.response.data
          this.error = _.reduce(e, (result, value, key) => {
            result[key] = value[0]
            return result
          }, {})
        }
      })
      this.message = null
      this.$refs.message.reset()
    }
  }
}
</script>
